<script setup lang="ts">
import { computed } from 'vue';

import type { FieldErrorProps } from '@shop/components/ui/FieldError.types';

const props = defineProps<FieldErrorProps>();

const messages = computed<string[]>(() => {
  if (!props.errors) {
    return [];
  }
  const list = Array.isArray(props.errors) ? props.errors : [props.errors];

  return list.filter(message => message !== '');
});
</script>

<template>
  <div v-if="messages.length > 0" :id="id" class="form__error">
    <span v-for="(message, index) in messages" :key="index" class="form__error-item">
      {{ message }}
    </span>
  </div>
</template>
